<template>
  <div>
    <toolbar type="contragent">
      <template slot="menu">
        <contragent-menu />
      </template>
      <template slot="tools">
        <div v-if="contragent" class="contragent-breadcrumbs">
          <breadcrumb>
            <breadcrumb-item
              :to="`/app/contracts/${contragent.parent_id}/overview`"
            >
              {{ contragent.main_contract_code }}
            </breadcrumb-item>
            <breadcrumb-item
              :to="`/app/contracts/${contragent.parent_id}/contragents`"
            >
              Подрядчики
            </breadcrumb-item>
            <breadcrumb-item>
              {{ contragent.performer }}
            </breadcrumb-item>
          </breadcrumb>
        </div>
        <i-button
          @click="toggleModal('history')"
          class="dropdown-settings-btn margin-right outline"
          shape="circle"
        >
          <icon type="md-list" />
        </i-button>
        <i-button
          @click="toggleModal('comments')"
          class="dropdown-settings-btn margin-right outline"
          shape="circle"
        >
          <icon type="ios-chatbubbles" />
        </i-button>
        <dropdown placement="bottom-end" @on-click="settingsClickHandler">
          <i-button class="dropdown-settings-btn" type="primary" shape="circle">
            <icon type="md-settings" />
          </i-button>
          <dropdown-menu slot="list">
            <dropdown-item class="ms-danger" name="delete">
              Удалить подрядчика
            </dropdown-item>
          </dropdown-menu>
        </dropdown>
      </template>
    </toolbar>

    <modal v-model="deleteModal" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление подрядчика</span>
      </p>
      <div class="ms-help" style="text-align:center">
        <p>Вы уверены, что хотите удалить данного подрядчика?</p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleteLoading"
          @click="deleteProjectHandler"
        >
          Удалить
        </i-button>
      </div>
    </modal>

    <modal :footer-hide="true" v-model="historyModal" width="420" :styles="{top: '80px'}">
      <p slot="header" style="text-align:center">
        <icon type="md-list" class="ms-help" />
        <span style="margin-left: 4px" class="ms-help">Последние действия</span>
      </p>
      <contract-history />
    </modal>

    <modal :footer-hide="true" v-model="commentsModal" width="420" :styles="{top: '80px'}">
      <p slot="header" style="text-align:center">
        <icon type="ios-chatbubbles" class="ms-help" />
        <span style="margin-left: 4px" class="ms-help">Комментарии</span>
      </p>
      <contract-comments />
    </modal>

    <inline-loader v-if="loading" :loading="loading" />
    <router-view v-else />
  </div>
</template>

<script>
import Toolbar from '@/components/toolbar/toolbar'
import ContragentMenu from '@/components/contragent/contragent-menu'
import ContractComments from '@/components/comments/comments'
import ContractHistory from '@/components/history/history'
import InlineLoader from '@/components/loaders/inline-loader'

export default {
  components: {
    Toolbar,
    ContragentMenu,
    ContractComments,
    ContractHistory,
    InlineLoader
  },
  data () {
    return {
      loading: false,
      contragent: null,
      deleteModal: false,
      deleteLoading: false,
      historyModal: false,
      commentsModal: false
    }
  },
  methods: {
    settingsClickHandler (value) {
      const { id } = this.$route.params

      switch (value) {
        case 'edit':
          this.$router.push(`/app/contracts/edit?id=${id}`)
          break
        case 'delete':
          this.deleteModal = true
          break
      }
    },
    toggleModal (type) {
      this[`${type}Modal`] = !this[`${type}Modal`]
    },
    async deleteProjectHandler () {
      const { id } = this.$route.params
      const { parent_id } = this.contragent

      try {
        this.deleteLoading = true
        await this.$store.dispatch('DELETE_REQUEST', {
          url: `page/contragent?id=${id}`
        })
        this.deleteLoading = false
        this.deleteModal = false
        this.$router.push(`/app/contracts/${parent_id}/contragents`)
        this.$Message.success('Подрядчик успешно удален')
      } catch (error) {
        console.log(error)
        this.deleteLoading = false
        this.deleteModal = false
        this.$Message.error('Произошла ошибка при удалении подрядчика')
      }
    },
    async getContragentInfo () {
      try {
        this.loading = true
        const { id } = this.$route.params
        const url = `page/contragent/${id}`
        this.contragent = await this.$store.dispatch('GET_REQUEST', { url })
        this.$store.commit('SET_CURRENT_CONTRACT', this.contragent)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getContragentInfo()
  }
}
</script>

<style lang="less">
.contragent-breadcrumbs {
  margin-right: 24px;

  .ivu-breadcrumb {
    font-size: 11px;
    display: flex;

    a {
      color: rgba(255, 255, 255, 0.6);
    }

    & > span:last-child {
      color: rgba(255, 255, 255, 1);
    }

    & > span {
      display: flex;
    }

    &-item-link {
      max-width: 164px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
